// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wn","title":"wo","year":"wp","genres":"wq","buttonWrapper":"wr","button":"ws yi"};